import { render, staticRenderFns } from "./investment-card.component.vue?vue&type=template&id=2680e8d7&scoped=true"
import script from "./investment-card.component.vue?vue&type=script&lang=js"
export * from "./investment-card.component.vue?vue&type=script&lang=js"
import style0 from "./investment-card.component.vue?vue&type=style&index=0&id=2680e8d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2680e8d7",
  null
  
)

export default component.exports